module.exports = __webpack_public_path__ + "static/media/about_img_2.659d831a.jpg";